<template>
	<div>
		<hero :content="heroContent" @hamburger="hamburgerClicked"></hero>
		<div class="clearfix">
			<voters class="voters col-xs-12"></voters>
		</div>
		<critic-quote :criticSliderContent="criticSlider1" class="col-xs-12 no-pad"></critic-quote>
		<div class="clearfix grid">
			<production-quote id="bestCinematographyProdQuote1" class="col-xs-12 col-md-6 no-pad" :prodQuote="productionQuote1"></production-quote>
			<div class="col-xs-12 col-md-6 image hideme"><img src="https://res.cloudinary.com/dwmmozjrb/image/upload/v1627839187/three-bb/best_cinematography_block_1.jpg" alt="Three Billboards Outside Ebbings, Missouri"></div>
			<production-quote id="bestCinematographyProdQuote2" class="col-xs-12 col-md-6 col-md-push-6 no-pad" :prodQuote="productionQuote2"></production-quote>
			<div class="col-xs-12 col-md-6 col-md-pull-6 video no-pad hideme">
				<video class="video-js vjs-default-skin" controls preload="none" data-setup='{"fluid": true}' poster="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/best_cinematography_01.jpg">
					<source src="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/best_cinematography_01.mp4" type='video/mp4' />
					<source src="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/best_cinematography_01.webm" type='video/webm' />
				</video>
			</div>
		</div>
		<div class="clearfix"></div>
		<click-thru :clickThru="clickThru" @clickThru="nextCategory"></click-thru>
		<social></social>
		<legal></legal>
	</div>
</template>
<script>
import Hero from '../../components/Hero';
import Voters from '../../components/Voters';
import CriticQuote from '../../components/CriticQuote';
import ProductionQuote from '../../components/ProductionQuote';
import SliderImage from '../../components/SliderImage';
import ClickThru from '../../components/ClickThru';
import Social from '../../components/Social';
import Legal from '../../components/Legal';

export default {
	name: 'best-cinematography',
	data: function() {
		return {
			heroContent: {
				"image": "best-cinematography-3b-lg",
				"mobileImage": "best-cinematography-3b-mob",
				"superHeader": "For Your Consideration",
				"header": "Best Cinematography",
				"subHeader": ['BEN DAVIS'],
				"isSubPage": true
			},
			clickThru: {
				superHeader: 'Return',
				mainText: 'Home',
				clickThruPath: ''
			},
			criticSlider1: [
				{
					text: "&#9733; &#9733; &#9733; &#9733;<br />A renegade masterpiece that will get you good.",
					author: '- ROLLING STONE'
				},
				{
					text: "&#9733; &#9733; &#9733; &#9733;<br />A darkly comic drama expertly structured with a rousing narrative.",
					author: '- NY Post'
				},
				{
					text: "A towering achievement. The best yet Martin McDonagh.",
					author: '- NYPost'
				},
				{
					text: "A Gut-Twisting Cinder-Black Comedy",
					author: '- The Telegraph'
				},				
			],
			productionQuote1: {
				text: "There’s something between Ben and Martin which allows Martin’s words and brain to come to visual life. Ben captures the rural American landscape in a way that feels dramatic, while filming the characters in a quite minimal, yet emotionally striking, way.",
				author: "Producer Graham Broadbent"
			},
			productionQuote2: {
				text: "Ben and I are both fans of American ‘70s films so we wanted that feel. Something beautiful but not overly modern, overly stylized or overly saturated.",
				author: "Martin McDonagh"
			}
		}
	},
	components: {
		Hero,
		Voters,
		CriticQuote,
		ProductionQuote,
		SliderImage,
		ClickThru,
		Social,
		Legal
	},
	methods: {
		hamburgerClicked: function() {
			console.log('hamburger passing through BestProduction');
			this.$emit('hamburger');
		},
		nextCategory: function() {
			console.log('nextCategory at categorypage');
			this.$emit('clickThru')
		}
	}
}
</script>


// WEBPACK FOOTER //
// BestCinematography.vue?4f570312